/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ metric: NonNullable<unknown> }} Coinvestments_Report_Trend_Title1Inputs */

const en_coinvestments_report_trend_title1 = /** @type {(inputs: Coinvestments_Report_Trend_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metric} trend`)
};

/**
* | output |
* | --- |
* | "{metric} trend" |
*
* @param {Coinvestments_Report_Trend_Title1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_trend_title1 = /** @type {((inputs: Coinvestments_Report_Trend_Title1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Trend_Title1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_trend_title1(inputs)
});
export { coinvestments_report_trend_title1 as "coInvestments_report_trend_title" }